<div class="live-button">
  <span>Live</span>
</div>